import { FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { social } from '../../utils/constants';
import { userlinks } from '../../utils/userlinks';
import logo from '../../assets/MullaLogo.jpg';
import { useGlobalContext } from '../../context/GlobalContext';

const UserSidebar = () => {
  const { showSidebar, toggleSidebar } = useGlobalContext();

  return (
    <SidebarContainer>
      <aside className={`${showSidebar ? 'sidebar show-sidebar' : 'sidebar'}`}>
        <div className='sidebar-header'>
          <img src={logo} className='logo' alt='MullaLogo' />
          <button className='close-btn' onClick={toggleSidebar}>
            <FaTimes />
          </button>
        </div>
        <ul className='links'>
          {userlinks.map(({ id, text, path }) => {
            return (
              <li key={id}>
                <Link to={path} onClick={toggleSidebar}>
                  {text}
                </Link>
              </li>
            );
          })}
        </ul>
        <div>
          <ul className='social-icons'>
            {social.map((socialIcon) => {
              const { id, url, icon } = socialIcon;
              return (
                <li key={id}>
                  <a href={url}>{icon}</a>
                </li>
              );
            })}
          </ul>
        </div>
        {/* <div className='sidebar-bottom'>
          <div className='login'>
            <Link to='/register' className='nav-links signup-link'>
              Sign up
            </Link>
            <button className='btn-primary btn-login'>
              <Link to='/login'>Login</Link>
            </button>
          </div>
        </div> */}
      </aside>
    </SidebarContainer>
  );
};

const SidebarContainer = styled.div`
  text-align: center;
  .sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--mainWhite);
    height: 5rem;
  }
  .sidebar-bottom {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    background: var(--mainWhite);
    height: 50%;
  }
  .login {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    margin-top: 3rem;
  }
  .btn-login {
    width: 60%;
  }
  .close-btn {
    background: white;
    border-color: transparent;
    color: var(--clr-primary-5);
    transition: var(--transition);
    cursor: pointer;
    color: var(--mainRed);
    svg {
      font-size: 2rem;
    }
  }
  .close-btn:hover {
    color: var(--primaryBtnColor);
  }
  .logo {
    margin-left: 15px;
    justify-self: center;
    height: 5rem;
    width: 175px;
  }
  .links {
    margin-bottom: 2rem;
  }
  .links a {
    display: block;
    text-align: left;
    font-size: 1rem;
    text-transform: capitalize;
    padding: 1rem 1.5rem;
    color: var(--clr-grey-3);
    transition: var(--transition);
    letter-spacing: var(--spacing);
  }
  .links a:hover {
    padding: 1rem 1.5rem;
    padding-left: 2rem;
    background: var(--clr-grey-10);
    color: var(--clr-grey-2);
  }
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--primarySidebarColor);
    transition: var(--transition);
    transform: translate(-100%);
    z-index: -1;
  }
  .show-sidebar {
    transform: translate(0);
    z-index: 999;
  }
  .cart-btn-wrapper {
    margin: 2rem auto;
  }

  @media screen and (min-width: 992px) {
    .sidebar {
      display: none;
    }
  }
  .social-icons {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    margin-bottom: 3rem;
    color: var(--mainWhite);
  }
  .social-icons a {
    margin: 0 0.5rem;
    color: var(--mainWhite);
    transition: var(--transition);
  }

  .social-icons a:hover {
    color: var(--primaryTxtColor);
  }
`;

export default UserSidebar;
